/**
 * Skida Markdown sintaksu iz teksta i vraća plain text.
 * Koristi se za prikaz excerpt-a u karticama / Featured banner-u gdje
 * `line-clamp` truncira tekst, pa nema prostora za pravi Markdown render.
 *
 * NE koristiti za full body Article-a — tamo ide `react-markdown`.
 */
export function stripMarkdown(text: string): string {
  if (!text) return '';

  return (
    text
      // Code blocks ```...``` — uklanjaju se u potpunosti (znaju biti dugi)
      .replace(/```[\s\S]*?```/g, '')
      // Headings (## Naslov → Naslov)
      .replace(/^#{1,6}\s+/gm, '')
      // Bold/italic (**text** → text, __text__ → text, *text* → text, _text_ → text)
      .replace(/\*\*([^*]+)\*\*/g, '$1')
      .replace(/__([^_]+)__/g, '$1')
      .replace(/\*([^*\n]+)\*/g, '$1')
      .replace(/(?<!\w)_([^_\n]+)_(?!\w)/g, '$1')
      // Images ![alt](url) → alt   (mora ići PRIJE linkova, jer image počinje sa !)
      .replace(/!\[([^\]]*)\]\([^)]+\)/g, '$1')
      // Links [text](url) → text
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
      // Inline code `code` → code
      .replace(/`([^`]+)`/g, '$1')
      // Blockquotes (> text → text)
      .replace(/^>\s*/gm, '')
      // List markers (- item, * item, + item, 1. item → item)
      .replace(/^\s*[-*+]\s+/gm, '')
      .replace(/^\s*\d+\.\s+/gm, '')
      // Horizontal rules (---, ***, ___)
      .replace(/^[-*_]{3,}\s*$/gm, '')
      // Newlines → space (za inline display)
      .replace(/\r?\n+/g, ' ')
      // Multiple spaces → single
      .replace(/\s{2,}/g, ' ')
      .trim()
  );
}
